import { createReducer, on } from '@ngrx/store';
import {
  deleteMultiplePayoutsAction,
  deleteMultiplePayoutsErrorAction,
  deleteMultiplePayoutsSuccessAction,
  deleteSinglePayoutAction,
  deleteSinglePayoutErrorAction,
  deleteSinglePayoutSuccessAction,
  getOtherSideTransactionListAction,
  getOtherSideTransactionsListErrorAction,
  getOtherSideTransactionsListSuccessAction,
} from '../actions/other-side-transaction.actions';
import { OtherSideTransactionForAdmin } from '../models/api/other-side-transaction.model';
import { PagingModel } from '../models/auxiliary/paging.model';
import { StateModel } from '../models/auxiliary/state.model';

export type OtherSideTransactionListState = StateModel<PagingModel<OtherSideTransactionForAdmin>>;

const INITIAL_STATE: OtherSideTransactionListState = {
  errors: null,
  data: {
    offset: 0,
    limit: 0,
    totalCount: 0,
    data: [],
  },
  loading: true,
};

export const otherSideTransactionListReducer = createReducer(
  INITIAL_STATE,
  on(getOtherSideTransactionsListSuccessAction, (state, { transactions }) => ({
    data: transactions,
    errors: null,
    loading: false,
  })),
  on(getOtherSideTransactionsListErrorAction, (state, { errors }) => ({
    ...state,
    errors,
    loading: false,
  })),
  on(getOtherSideTransactionListAction, () => ({
    ...INITIAL_STATE,
    errors: null,
    loading: true,
  })),
  on(deleteSinglePayoutAction, deleteMultiplePayoutsAction, (state) => ({
    ...state,
    errors: null,
    loading: true,
  })),
  on(deleteSinglePayoutSuccessAction, (state, { hashId }) => ({
    ...state,
    loading: false,
    errors: null,
    data: {
      ...state.data,
      data: state.data?.data?.filter((transaction) => transaction.id !== hashId),
    },
  })),
  on(deleteMultiplePayoutsSuccessAction, (state, { hashIds }) => ({
    ...state,
    loading: false,
    errors: null,
    data: {
      ...state.data,
      data: state.data?.data?.filter((transaction) => !hashIds.includes(transaction.id)),
    },
  })),
  on(deleteSinglePayoutErrorAction, deleteMultiplePayoutsErrorAction, (state, { errors }) => ({
    ...state,
    loading: false,
    errors,
  })),
);
